import { render, staticRenderFns } from "./menu-top-link.vue?vue&type=template&id=4ce6fa44&"
import script from "./menu-top-link.vue?vue&type=script&lang=js&"
export * from "./menu-top-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports